import { useState, useEffect, useCallback } from 'react';

type Theme = 'light' | 'dark';

const STORAGE_KEY = 'mesurette-theme';

export function useTheme() {
    const [theme, setThemeState] = useState<Theme>(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY) as Theme | null;
            if (saved === 'light' || saved === 'dark') return saved;
            // Respecter la préférence système au premier lancement
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
        } catch {}
        return 'light';
    });

    // Appliquer la classe sur <html> dès le montage et à chaque changement
    useEffect(() => {
        const root = document.documentElement;
        if (theme === 'dark') {
            root.classList.add('dark');
        } else {
            root.classList.remove('dark');
        }
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch {}
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setThemeState(prev => (prev === 'light' ? 'dark' : 'light'));
    }, []);

    const setTheme = useCallback((t: Theme) => {
        setThemeState(t);
    }, []);

    return { theme, toggleTheme, setTheme, isDark: theme === 'dark' };
}
